/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AvailableCurrencyDto } from '../models/AvailableCurrencyDto';
import type { CalculatePaymentIntentCryptoRefundFeeDto } from '../models/CalculatePaymentIntentCryptoRefundFeeDto';
import type { CreatePaymentIntentRequestDto } from '../models/CreatePaymentIntentRequestDto';
import type { CryptoRefundDto } from '../models/CryptoRefundDto';
import type { CryptoRefundFeeDto } from '../models/CryptoRefundFeeDto';
import type { CustomerApiKeyResponseDto } from '../models/CustomerApiKeyResponseDto';
import type { CustomerCryptoPayApiKeyRequestDto } from '../models/CustomerCryptoPayApiKeyRequestDto';
import type { CustomerCryptoPayApiKeySlimDto } from '../models/CustomerCryptoPayApiKeySlimDto';
import type { DeleteCustomerApiKeyResponseDto } from '../models/DeleteCustomerApiKeyResponseDto';
import type { PaymentIntentDto } from '../models/PaymentIntentDto';
import type { PaymentIntentProjectionDtoFramedResultDto } from '../models/PaymentIntentProjectionDtoFramedResultDto';
import type { PaymentIntentProjectionDtoSearchRequest } from '../models/PaymentIntentProjectionDtoSearchRequest';
import type { PayoutIntentProjectionDtoFramedResultDto } from '../models/PayoutIntentProjectionDtoFramedResultDto';
import type { PayoutIntentProjectionDtoSearchRequest } from '../models/PayoutIntentProjectionDtoSearchRequest';
import type { CancelablePromise } from '../../../core/CancelablePromise';
import type { BaseHttpRequest } from '../../../core/BaseHttpRequest';
export class CryptoPayService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param requestBody
     * @returns string Created
     * @throws ApiError
     */
    public postApiCryptoPayPaymentIntents(
        requestBody?: CreatePaymentIntentRequestDto,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/crypto-pay/payment-intents',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @returns AvailableCurrencyDto Success
     * @throws ApiError
     */
    public getApiCryptoPayAvailableCurrencies(): CancelablePromise<Array<AvailableCurrencyDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/crypto-pay/available-currencies',
        });
    }
    /**
     * @param requestBody
     * @returns PaymentIntentProjectionDtoFramedResultDto Success
     * @throws ApiError
     */
    public postApiCryptoPayPaymentIntentsSearch(
        requestBody?: PaymentIntentProjectionDtoSearchRequest,
    ): CancelablePromise<PaymentIntentProjectionDtoFramedResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/crypto-pay/payment-intents/search',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns PayoutIntentProjectionDtoFramedResultDto Success
     * @throws ApiError
     */
    public postApiCryptoPayPayoutIntentsSearch(
        requestBody?: PayoutIntentProjectionDtoSearchRequest,
    ): CancelablePromise<PayoutIntentProjectionDtoFramedResultDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/crypto-pay/payout-intents/search',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CustomerApiKeyResponseDto Created
     * @throws ApiError
     */
    public postApiCryptoPayCustomerApiKeys(
        requestBody?: CustomerCryptoPayApiKeyRequestDto,
    ): CancelablePromise<CustomerApiKeyResponseDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/crypto-pay/customer-api-keys',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @returns CustomerCryptoPayApiKeySlimDto Success
     * @throws ApiError
     */
    public getApiCryptoPayCustomerApiKeys(): CancelablePromise<Array<CustomerCryptoPayApiKeySlimDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/crypto-pay/customer-api-keys',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns CryptoRefundFeeDto Success
     * @throws ApiError
     */
    public postApiCryptoPayPaymentIntentsCryptoRefundsFee(
        requestBody?: CalculatePaymentIntentCryptoRefundFeeDto,
    ): CancelablePromise<CryptoRefundFeeDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/crypto-pay/payment-intents/crypto-refunds/fee',
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param paymentIntentId
     * @returns CryptoRefundDto Created
     * @throws ApiError
     */
    public postApiCryptoPayPaymentIntentsCryptoRefunds(
        paymentIntentId: string,
    ): CancelablePromise<CryptoRefundDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/crypto-pay/payment-intents/crypto-refunds',
            query: {
                'paymentIntentId': paymentIntentId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param paymentIntentId
     * @returns PaymentIntentDto Success
     * @throws ApiError
     */
    public postApiCryptoPayPaymentIntentsManuallyCompleted(
        paymentIntentId: string,
    ): CancelablePromise<PaymentIntentDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/crypto-pay/payment-intents/manually-completed',
            query: {
                'paymentIntentId': paymentIntentId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param apiKey
     * @param requestBody
     * @returns CustomerApiKeyResponseDto Created
     * @throws ApiError
     */
    public postApiCryptoPayCustomerApiKeysReset(
        apiKey: string,
        requestBody?: CustomerCryptoPayApiKeyRequestDto,
    ): CancelablePromise<CustomerApiKeyResponseDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/crypto-pay/customer-api-keys/{apiKey}/reset',
            path: {
                'apiKey': apiKey,
            },
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param apiKey
     * @param requestBody
     * @returns DeleteCustomerApiKeyResponseDto Success
     * @throws ApiError
     */
    public postApiCryptoPayCustomerApiKeysDelete(
        apiKey: string,
        requestBody?: CustomerCryptoPayApiKeyRequestDto,
    ): CancelablePromise<DeleteCustomerApiKeyResponseDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/crypto-pay/customer-api-keys/{apiKey}/delete',
            path: {
                'apiKey': apiKey,
            },
            body: requestBody,
            mediaType: 'application/json-patch+json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @returns any Created
     * @throws ApiError
     */
    public postApiCryptoPayCustomerMerchantSettings(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/crypto-pay/customer-merchant-settings',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param paymentIntentId
     * @returns string Success
     * @throws ApiError
     */
    public getApiCryptoPayPaymentIntentsCryptoRefundsLink(
        paymentIntentId: string,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/crypto-pay/payment-intents/{paymentIntentId}/crypto-refunds/link',
            path: {
                'paymentIntentId': paymentIntentId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Server Error`,
            },
        });
    }
}
